/** Either a string for aria-label, or `{ by }` for aria-labelledby */
export type AriaLabel =
    | string
    | {
          /** Aria-labelledby. This must be the ID of another element containing text */
          by: string;
      };

export namespace AriaLabel {
    /**
     * Value for `aria-label` when {@link AriaLabel} is a string.
     * Returns a value or null, so it can be bound directly to template
     */
    export function text(label?: AriaLabel | null): string | null {
        return typeof label === "string" ? label || null : null;
    }

    /**
     * Value for `aria-labelledby` when {@link AriaLabel} is `{ by }`.
     * Returns a value or null, so it can be bound directly to template
     */
    export function labelledBy(label?: AriaLabel | null): string | null {
        return typeof label === "object" ? label?.by || null : null;
    }
}
